import { createClient } from '@supabase/supabase-js';

// Tu trouveras ces infos dans Supabase (Settings > API)
const supabaseUrl = 'https://hbjrtoodpeshpwzdtupw.supabase.co'; 
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhianJ0b29kcGVzaHB3emR0dXB3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzc5ODUwNzYsImV4cCI6MjA5MzU2MTA3Nn0.vPryw5kuE_-E7XgmMKi6oYnxwfJaDwCh06cCBD5DugQ';

export const supabase = createClient(supabaseUrl, supabaseKey);